import React from "react";
import { IoIosCheckbox, IoIosCheckboxOutline, IoIosRadioButtonOff, IoIosRadioButtonOn } from "react-icons/io";

const OptionList = ({ options, type, onSelect }: any) => {
  console.log("options", options);
  return (
    <div className="flex flex-wrap gap-2">
      {options?.map((opt: any, index: number) => (
        <div
          key={index}
          onClick={() => onSelect(index)}
          className={`px-3 py-2 border rounded-md cursor-pointer text-sm transition
            ${
              opt.selected
                ? "bg-blue-500 text-white border-blue-500"
                : "bg-gray-100 hover:bg-gray-200"
            }`}
        >
          <div className="flex items-center gap-2">
            {type === 1 ? (
              opt.selected ? (
                <IoIosRadioButtonOn size={18} />
              ) : (
                <IoIosRadioButtonOff size={18} />
              )
            ) : opt.selected ? (
              <IoIosCheckbox size={18} />
            ) : (
              <IoIosCheckboxOutline size={18} />
            )}{" "}
            {opt.survey_Options}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OptionList;
